import React from "react";

import "./container.css";

export default({children}) => (<div style={{
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    zIndex: 1,
    position: "relative",
    fontFamily: "nunito",
    fontWeight: 600
  }}>{children}</div>);



// WEBPACK FOOTER //
// ./src/components/container.js